class WifiVideoMedia extends HTMLElement {
    connectedCallback() {
        const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;

        // Grab the direct video child, or the template child if any
        const videoChild = this.querySelector('video');
        const templateChild = this.querySelector('template');
        const fallbackUrl = this.getAttribute('fallback');

        // Show video ONLY on WiFi/ethernet. On cellular (any speed) or saveData, show fallback image.
        const isSlowOrCellular = connection && (connection.type === 'cellular' || connection.saveData || (connection.type && connection.type !== 'wifi' && connection.type !== 'ethernet'));
        if (isSlowOrCellular) {
            this._showFallback(videoChild, fallbackUrl);
        } else {
            // Good connection. Proceed with rendering the video from template if it exists
            let video = videoChild;
            if (templateChild) {
                this.appendChild(templateChild.content.cloneNode(true));
                video = this.querySelector('video');
            }

            // Try to autoplay — if blocked (Low Power Mode, browser-in-app, etc.), show poster/fallback
            if (video) {
                this._tryAutoplay(video, fallbackUrl);
            }
        }
    }

    _tryAutoplay(video, fallbackUrl) {
        const playPromise = video.play();
        if (playPromise !== undefined) {
            playPromise.catch(() => {
                // Autoplay was blocked — replace video with poster or fallback image
                const posterUrl = video.getAttribute('poster') || fallbackUrl;
                if (posterUrl) {
                    const img = document.createElement('img');
                    img.src = posterUrl;
                    img.alt = 'Video background';
                    img.loading = 'eager';
                    img.style.cssText = 'width:100%;height:100%;object-fit:cover;';
                    video.replaceWith(img);
                }
            });
        }
    }

    _showFallback(videoChild, fallbackUrl) {
        if (fallbackUrl) {
            this.innerHTML = `<img src="${fallbackUrl}" alt="Video fallback image" loading="lazy" width="100%" height="100%" style="object-fit:cover">`;
        } else if (videoChild) {
            // Fallback not provided, at least try removing the video to save data
            videoChild.remove();
        }
    }
}

if (!customElements.get('wifi-video-media')) {
    customElements.define('wifi-video-media', WifiVideoMedia);
}
